import React from 'react';
import MessageLayout from '../../components/domain/MessageLayout';
import { PageHeader } from '../../components/ui/Primitives';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';

export default function AdminMessaging() {
  const { user } = useAuth();
  const { messages = [], users = [], addMessage, updateMessage, loading = false } = useData() || {};
  return <div><PageHeader eyebrow="Advanced" title="Messages" description="Direct platform conversations with students and lecturers." /><MessageLayout currentUser={user} role="admin" messages={messages} users={users} addMessage={addMessage} updateMessage={updateMessage} recipientRoles={['student', 'teacher']} loading={loading} /></div>;
}
